import React from "react";
import styled from "styled-components";
import Theme from "../../../vars/ThemeOptions";
import { Button, H4 } from "../../common";

const Wrap = styled.div`
  width: 100%;
  height: 17rem;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  background: ${Theme.hex("blue")};
  border-left: 4rem solid ${Theme.hex("green")};
  .prev-next-wrap {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .text {
      color: ${Theme.hex("white")};
      font-size: 2rem;
    }
    a {
      padding: 1rem 3rem;
    }
  }
  @media only screen and (max-width: 767px) {
    .prev-next-wrap {
      .text {
        font-size: 1.5rem;
      }
      a {
        padding: 1rem;
      }
    }
  }
`;

const TopicPrevNext = ({ currTopic, topics, currChapter }) => {
  // console.log("currTopic: ",currTopic)
  // console.log("topics: ",topics)
  let prevTopicSlug = null;
  let nextTopicSlug = null;
  let prevTitle;
  let nextTitle;
  //console.log(topics)
  topics && topics.length && topics.forEach((topic, i) => {
    if (topic.title === currTopic) {
      if (topics[i - 1] && topics[i + 1]) {
        prevTopicSlug = topics[i - 1].slug;
        nextTopicSlug = topics[i + 1].slug;
        prevTitle = topics[i - 1].title;
        nextTitle = topics[i + 1].title;
      } else if (topics[i - 1]) {
        prevTopicSlug = topics[i - 1].slug;
        prevTitle = topics[i - 1].title;
      } else if (topics[i + 1]) {
        nextTopicSlug = topics[i + 1].slug;
        nextTitle = topics[i + 1].title;
      }
    }
  });
  // console.log("prevTopicSlug: ",prevTopicSlug)
  // console.log("nextTopicSlug: ",nextTopicSlug)
  return topics && topics.length ? (
    <Wrap>
      <div className="prev-next-wrap">
        {prevTopicSlug && (
          <>
            <H4 white>{prevTitle}</H4>
            {/* <p className="text">Previous Topic</p> */}
            <Button white to={`/` + currChapter + `/` + prevTopicSlug}>
              Previous Topic
            </Button>
          </>
        )}
      </div>
      <div className="prev-next-wrap">
        {nextTopicSlug && (
          <>
            <H4 white>{nextTitle}</H4>
            {/* <p className="text">Next Topic</p> */}
            <Button white to={`/` + currChapter + `/` + nextTopicSlug}>
              Next Topic
            </Button>
          </>
        )}
      </div>
    </Wrap>
  ) : null;
};

export default TopicPrevNext;
